module.exports = __webpack_public_path__ + "img/mirt_i.d7f9368a.svg";